import axios from 'axios'
import { baseApiUrlVersioned } from "./repository"
import { requestInterceptor, responseInterceptor } from "./interceptors"

const api = axios.create({
  baseURL: baseApiUrlVersioned
})

api.interceptors.request.use(
  config => requestInterceptor.onConfig(config, localStorage),
  requestInterceptor.onError
)

api.interceptors.response.use(
  responseInterceptor.onResponse, 
  err => responseInterceptor.onError(err, {
    auth: window.$nuxt.$auth, 
    router: window.$nuxt._router,
    context: window.$nuxt
  })
)

export { api }

export default { api }